import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { setQuestion } from 'src/app/actions/question.actions';
import { Question, QuestionData } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { QuestionService } from 'src/app/services/question.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuestionComponent implements OnInit {

  @Input() colors: any;

  public question$: Observable<Question>;
  public test$: Observable<Test>;

  public currentTest: Test;
  public questionType: string;
  public timeRemaining: number;
  public timeSpent: number;
  public optionId: number;

  public timeInterval;

  public questionData: QuestionData;

  constructor(
    private store: Store,
    private questionService: QuestionService,
    private utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    // obtenemos los datos de la pregunta y el test de la store
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.pipe(take(1)).subscribe(test => {
      this.currentTest = test;
    });

    this.question$.subscribe(questions => {
      this.questionData = questions.questions[0];
      clearInterval(this.timeInterval);

      // comprobamos el timpo de pregunta que estamos recibiendo
      if (questions?.testModelId) {
        if (this.questionData.media) {
          if (this.questionData.media.includes('audio')) {
            this.questionType = 'audio';
          } else {
            this.questionType = 'image';
          }
        } else {
          if (this.questionData.description.length > 200) {
            this.questionType = 'longQuestion';
          } else {
            this.questionType = 'shortQuestion';
          }
        }
      }

      const now = new Date();
      const utcNow = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      const levelStartedAt = new Date(questions.levelStartedAt);

      const levelEndsAt = levelStartedAt.getTime() + (questions.maxLevelDuration * 1000);

      let difference = (levelEndsAt - utcNow.getTime()) / 1000;

      this.timeInterval = setInterval(() => {
        difference >= 0 ? difference-- : difference = 0;
        this.timeRemaining = Math.round(difference / 60);
        this.timeSpent = questions.maxLevelDuration / 60 - this.timeRemaining;
      }, 1000);


    });
  }

  public setAnswer() {
    // comprobamos si hay una respuesta contestada
    if (this.optionId) {
      this.question$.pipe(take(1)).subscribe(question => {
        if (this.questionType === 'audio') {
          document.querySelector('audio').pause();
        }
      });

      this.questionService.putAnswer(this.currentTest.token, [this.optionId]).subscribe(res => {
        // si el nivel no esta completado preguntamos por la siguiente pregunta
        // if (!res.levelCompleted) {
        this.questionService.getNextQuestion(this.currentTest.token).subscribe(questions => {
          this.store.dispatch(setQuestion(questions));

        }, error => {
          console.log(error);
        });

        this.optionId = undefined;

      }, error => {
        console.log(error);
      });
    }
  }

}
